module.exports = __webpack_public_path__ + "static/media/Akkurat.3e6df94f.woff";